import { createFileRoute } from "@tanstack/react-router";
import { EntryPointsList } from "../../components/entry-points/entry-points-list";
import { entryPointsSearch } from "../../components/entry-points/entry-points-search";
import { requireAdminRole } from "../../lib/auth/guards";

/**
 * Game Settings → Entry points. The list itself is `EntryPointsList`, shared
 * with the A&D "Entry points" tab (M9b §3.4): same URL state, same table.
 */
export const Route = createFileRoute("/_app/settings/entry-points")({
	beforeLoad: ({ context }) => requireAdminRole(context.session),
	validateSearch: entryPointsSearch,
	component: EntryPointsPage,
});

function EntryPointsPage() {
	const { session } = Route.useRouteContext();
	return <EntryPointsList session={session} search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
